/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Page_Error_ReloadInputs */

const fr_page_error_reload = /** @type {(inputs: Page_Error_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Recharger la page`)
};

const en_page_error_reload = /** @type {(inputs: Page_Error_ReloadInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Reload page`)
};

/**
* | output |
* | --- |
* | "Reload page" |
*
* @param {Page_Error_ReloadInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const page_error_reload = /** @type {((inputs?: Page_Error_ReloadInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Page_Error_ReloadInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_page_error_reload(inputs)
	return fr_page_error_reload(inputs)
});